// extracted by mini-css-extract-plugin
module.exports = {"table":"DashboardTable_table__2ZfT6","red":"DashboardTable_red__dOGc4","green":"DashboardTable_green__1X3BV","yellow":"DashboardTable_yellow__3BZAO"};